import _ from 'underscore';
import Localizer from 'localizer';
import Backbone from 'backbone';
import ConsentText from 'models/gdpr/Consent';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import ModelSynchronizer from 'utils/ModelSynchronizer';
import LocaleMapper from 'utils/LocaleMapper';
import GdprUtil from 'utils/gdpr/GdprUtil';
import templateHtml from 'views/gdpr/templates/gdprModalWithSwitch.html';

let Events = {
    TOGGLE_SWITCH: 'TOGGLE_SWITCH'
};

let GdprModalWithSwitch = Backbone.View.extend({
    events: {
        'change #productEnhancementBtnSwitch': 'productEnhancementSwitchChange'
    },
    template: _.template(templateHtml),

    initialize: function(args) {
        this.modalTopTitle = args.modalTopTitle;
        this.isFeatureAccepted = args.isFeatureAccepted;
        this.consentType = args.consentType;
        this.thirdPartyApp = args.thirdPartyApp;
        this.thirdPartyUrl = args.thirdPartyUrl;
        this.customCancelText = args.customCancelText;

        this.language = LocaleMapper.getFullLocale(ViewerUserPreferences.get('preferredLocale'));

        this.gdprConsentText = new ConsentText({
            consentTypeId: this.consentType,
            locale: this.language
        });
    },

    render: function() {
        var modelSynchronizer = new ModelSynchronizer();
        modelSynchronizer.addModel({ model: this.gdprConsentText, required: true });
        modelSynchronizer.on(ModelSynchronizer.Events.SYNCHRONIZED, this.getConsentModal, this);
        modelSynchronizer.fetchModels();
    },

    getConsentModal: function() {
        this.consentText = this.gdprConsentText.attributes[0];
        var modalTile,
            modalBody,
            saveBtn,
            cancelBtn,
            footerLink,
            footerTextLink,
            footerPrimaryButtonClasses,
            switchIsChecked;

        modalTile = this.consentText.displayName;
        let consentContentBlocksWithoutFirstBlock = () => {
            return this.consentText.consentCopyBlocks.filter((item, index) => {
                if (index !== 0) {
                    return item;
                }
            });
        };

        modalBody = GdprUtil.getGdprContentText(consentContentBlocksWithoutFirstBlock(), this.thirdPartyApp);
        saveBtn = Localizer.localize('button_done');
        switchIsChecked = this.isSwitchInitiallyChecked();
        footerLink = this.thirdPartyUrl
            ? this.thirdPartyUrl
            : this.consentText.consentLinks.length > 0
            ? this.consentText.consentLinks[0].url
            : '';
        footerTextLink = this.getFooterTextLink(this.consentText.consentLinks);
        footerPrimaryButtonClasses = '';

        this.$el.html(
            this.template({
                Localizer: Localizer,
                modalTopTitle: this.modalTopTitle,
                modalTitle: modalTile,
                modalBody: modalBody,
                saveBtn: saveBtn,
                cancelBtn: this.customCancelText ? this.customCancelText : cancelBtn,
                footerLink: footerLink,
                footerTextLink: footerTextLink,
                footerPrimaryButtonClasses: footerPrimaryButtonClasses,
                switchIsChecked: switchIsChecked
            })
        );
    },

    isSwitchInitiallyChecked: function() {
        return this.isFeatureAccepted;
    },

    isSwitchChecked: function() {
        return !!this.$('#productEnhancementBtnSwitch').attr('checked');
    },

    productEnhancementSwitchChange: function(e) {
        e.preventDefault();
        e.stopPropagation();
        let checkbox = jQuery(e.currentTarget);
        let isChecked = checkbox.hasClass('checked');
        checkbox.toggleClass('checked', !isChecked);
        checkbox.attr('checked', !isChecked);
        this.trigger(Events.TOGGLE_SWITCH);
    },

    enableSwitch() {
        this.$('#productEnhancementBtnSwitch').attr('disabled', false);
    },

    disableSwitch() {
        this.$('#productEnhancementBtnSwitch').attr('disabled', true);
    },

    getFooterTextLink: function(footerTextLink) {
        if (footerTextLink.length) {
            if (this.thirdPartyApp) {
                return footerTextLink[0].text.split('[APP]').join(this.thirdPartyApp);
            } else {
                return footerTextLink[0].text;
            }
        }
        return '';
    },

    getConsentVersion: function() {
        return this.consentText.version;
    }
});

GdprModalWithSwitch.Events = Events;
export default GdprModalWithSwitch;
